import React from "react";
import "draft-js-linkify-plugin/lib/plugin.css";
import Editor, { composeDecorators } from "draft-js-plugins-editor";
import MultiDecorator from "draft-js-plugins-editor/lib/Editor/MultiDecorator";

import { EditorState, CompositeDecorator } from "draft-js";

import createImagePlugin from "draft-js-image-plugin";

import createAlignmentPlugin from "draft-js-alignment-plugin";

import createFocusPlugin from "draft-js-focus-plugin";

import createResizeablePlugin from "draft-js-resizeable-plugin";

import createVideoPlugin from "draft-js-video-plugin";

import createLinkifyPlugin from "draft-js-linkify-plugin";

import createCounterPlugin from "draft-js-counter-plugin";
// import mockUpload from './mockUpload';

const focusPlugin = createFocusPlugin();
const resizeablePlugin = createResizeablePlugin();
// const blockDndPlugin = createBlockDndPlugin();
const alignmentPlugin = createAlignmentPlugin();

const counterPlugin = createCounterPlugin();

const linkifyPlugin = createLinkifyPlugin();

const videoPlugin = createVideoPlugin();

const decorators = composeDecorators(
  resizeablePlugin.decorator,
  alignmentPlugin.decorator,
  focusPlugin.decorator
  //   blockDndPlugin.decorator
);
const imagePlugin = createImagePlugin({ decorators });

// const dragNDropFileUploadPlugin = createDragNDropUploadPlugin({
//   handleUpload: mockUpload,
//   addImage: imagePlugin.addImage,
// });

const plugins = [
  //   blockDndPlugin,
  focusPlugin,
  alignmentPlugin,
  resizeablePlugin,
  imagePlugin,
  videoPlugin,
  counterPlugin,
  linkifyPlugin,
];

function getPluginDecoratorArray() {
  let decorators = [];
  let plugin;
  // check each plugin that will be used in the editor for decorators
  // (retrieve listOfPlugins however makes sense in your code)
  for (plugin of plugins) {
    if (plugin.decorators !== null && plugin.decorators !== undefined) {
      // if the plugin has any decorators, add them to a list of all decorators from all plugins
      decorators = decorators.concat(plugin.decorators);
    }
  }
  return decorators;
}

function grabAllPluginDecorators() {
  // I can't quite remember why I had to wrap things in this exact way, but found that I ran into
  // errors if I did not both have a MultiDecorator and a CompositeDecorator wrapping
  // This MultiDecorator can now be used as shown in my previous post.
  return new MultiDecorator([
    new CompositeDecorator(getPluginDecoratorArray()),
  ]);
}

class ReadOnlyEditor extends React.Component {
  // handleChange = editorState => {
  //   this.props.handleEditor(editorState);

  // };

  render() {
    const { editorState } = this.props;

    const contentState = editorState.getCurrentContent();
    let decorator = grabAllPluginDecorators();
    const newEditorState = EditorState.createWithContent(
      contentState,
      decorator
    );
    return (
      <Editor editorState={newEditorState} plugins={plugins} readOnly={true} />
    );
  }
}

// function setEditorContent(feed_description) {
//   console.log("feed_description", feed_description);
//   const rawEditorData = feed_description ? JSON.parse(feed_description) : null;
//   if (rawEditorData !== null) {
//     const contentState = convertFromRaw(rawEditorData);
//     return EditorState.createWithContent(contentState);
//     //this.setState({ editorState: newEditorState });
//   }
// }

export default ReadOnlyEditor;
